import { Box, Button, Flex, customStyled } from '@mafc/trolly';
import FONTFAMILY from 'theme/fontFamily';

export const PopupWrapper = customStyled(Box)(() => ({
  fontFamily: FONTFAMILY.PRIMARY,
}));

export const UpdateButton = customStyled(Button)(({ theme }) => ({
  borderRadius: theme.radii[2],
  fontWeight: theme.fontWeights[8],
}));

export const ButtonRow = customStyled(Flex)(({ theme }) => ({
  justifyContent: 'space-evenly',
}));

export const Message = customStyled(Flex)(({ theme }) => ({
  marginBottom: theme.space[3],
  color: theme.colors.black,
  fontSize: theme.fontSizes[3],
  justifyContent: 'center',
}));
